"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickstartCTAButton = exports.QuickstartCTA = exports.Content = exports.Picture = exports.QuickstartTile = exports.Claim = exports.Quickstart = exports.BoxBottom = exports.BoxMain = exports.Box = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.Box = styled_components_1.default.div `
	width: 100%;
	min-height: 380px;
	position: relative;
	background: ${props => props.theme.color.white};
	border-radius: 4px;
	overflow: hidden;
	box-shadow: 0 15px 35px rgb(50 50 77 / 10%), 0 5px 30px rgb(0 0 0 / 7%);
	display: flex;
	flex-direction: column;
`;
exports.BoxMain = styled_components_1.default.div `
	flex-grow: 1;
`;
exports.BoxBottom = styled_components_1.default.div `
	text-align: center;
	color: ${props => props.theme.color.brand1};
	background: ${props => props.theme.color.gray1};
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.Quickstart = styled_components_1.default.div `
	width: 100%;
	text-align: center;
	display: flex;
	justify-items: space-between;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}
`;
exports.Claim = styled_components_1.default.div `
	text-align: center;
	color: ${props => props.theme.color.gray6};
	font-size: 1.2em;
	padding: 2em 3em 2em;
	a {
		text-decoration: underline;
	}
`;
exports.QuickstartTile = styled_components_1.default.div `
	width: 100%;
	padding: 1em 2em 2em;
	display: flex;
	position: relative;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('sm')} {
		padding: 2em 2em 1.5em;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		padding: 3em 2em 1.5em;
		width: 33%;
	}
`;
exports.Picture = styled_components_1.default.div `
	width: 150px;
	height: 150px;
	overflow: hidden;
	align-self: center;
	& img {
		display: block;
		max-width: 100%;
	}
`;
exports.Content = styled_components_1.default.dl `
	align-self: center;
	flex: 1;
	text-align: center;

	dt {
		color: ${props => props.theme.color.brand2};
		font-size: 1.2em;
		font-weight: 700;
		margin: 0 0 0.5em;
	}
`;
exports.QuickstartCTA = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	padding: 0 0 3em 0;
`;
exports.QuickstartCTAButton = (0, styled_components_1.default)(elements_1.Button) ``;
